module.exports = __webpack_public_path__ + "img/icon-ms.ea363875.svg";